<div class="entity-card">
<div class="section-header">
  <span>Amount of Contribution</span>
</div>

<div class="section-body">
  <div class="ownership-row">
    <div>
      <span class="label">Form of ownership : </span>
      <span class="value">
        <span *ngIf="amountOfContribution?.usesStateCapital == true">State</span>
        <span *ngIf="amountOfContribution?.usesStateCapital == false">Private</span>
      </span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Currency</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{amountOfContribution?.currencyCode}}</span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Amount of contribution</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{amountOfContribution?.amountOfContribution | number:'1.0-2'}}</span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Exchange Rate</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{(getExchangeRate(amountOfContribution?.currencyCode!) | number:'1.0-2') ?? '-'}}</span>
    </div>
  </div>

  <div nz-row class="section-row">
    <div nz-col nzSpan="11" class="section-label">Exchange Date</div>
    <div nz-col nzSpan="13">
      <span class="section-value">{{getExchangeDate(amountOfContribution?.currencyCode!) ?? '-'}}</span>
    </div>
  </div>

  <div class="summary">
    <div>
      <span class="label">Amount of contribution in KZT : </span>
      <span class="value">{{amountOfContribution?.amountOfContributionKzt | number:'1.0-2'}}</span>
    </div>
    <div nz-row>
      <div nz-col nzSpan="12">
        <span class="label">Amount of private capital in KZT : </span>
        <span class="value">{{amountOfContribution?.amountOfPrivateCapital | number:'1.0-2'}}</span>
      </div>
      <div nz-col nzSpan="12">
        <span class="label">Share of private capital : </span>
        <span class="value">{{amountOfContribution?.shareOfPrivateCapital | number:'1.0-2'}}%</span>
      </div>
    </div>
    <div nz-row>
      <div nz-col nzSpan="12">
        <span class="label">Amount of state capital in KZT: </span>
        <span class="value">{{amountOfContribution?.amountOfStateCapital | number:'1.0-2'}} </span>
      </div>
      <div nz-col nzSpan="12">
        <span class="label">Share of state capital : </span>
        <span class="value">{{amountOfContribution?.shareOfStateCapital | number:'1.0-2'}}%</span>
      </div>
    </div>
  </div>
</div>
</div>

<div class="entity-card">
<div class="section-header">
  <span>Shareholders</span>
</div>

<div class="shareholders-list">
  <div nz-row *ngFor="let founder of amountOfContribution?.founders; let last = last"
       class="shareholder-row"
       [class.border-bt]="!last"
  >
    <div nz-col nzSpan="12">
      <div *ngIf="founder.isIndividual" class="shareholder-info">
        <nz-avatar nzIcon="user" class="avatar"></nz-avatar>
        <div class="shareholder-text">
          <div class="name">{{founder.firstName}} {{founder.lastName}}</div>
          <div class="type">Individual</div>
        </div>
      </div>
      <div *ngIf="!founder.isIndividual" class="shareholder-info">
        <nz-avatar nzSrc="assets/icons/corporate.svg" class="avatar"></nz-avatar>
        <div class="shareholder-text">
          <div class="name">{{founder.companyName}}</div>
          <div class="type">Body Corporate</div>
        </div>
      </div>
    </div>
    <div nz-col nzSpan="12">
      <div class="shares-list">
        <div *ngFor="let contribution of founder.contributions">
          <div class="share-card">
            <div class="share-row">
              <span class="label">Amount of contribution</span>
              <span class="value">{{contribution.amount | number:'1.0-2'}}</span>
            </div>
          </div>
          <div class="share-summary">
            <div class="share-row">
              <span class="label">Ownership interest</span>
              <span class="value">{{contribution.ownershipInterest | number: '1.0-3'}}%</span>
            </div>
            <div class="share-row">
              <span class="label">Amount of contribution in KZT </span>
              <span class="value">{{contribution.amountKzt | number:'1.0-2'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
